import { expandProductsByColourVariants } from './productVariantExpander';
export function getRenderedProductCount(products, enableColourSwatch) {
    if (enableColourSwatch) {
        return products.length;
    }
    return expandProductsByColourVariants(products).length;
}
export function formatProductCount(count) {
    const itemLabel = count === 1 ? 'item' : 'items';
    return `${count} ${itemLabel}`;
}
